// extracted by mini-css-extract-plugin
export default {"link":"WeatherForecast_link__adtvd","weather":"WeatherForecast_weather__XAZ7b"};